import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import Button from 'components/_atoms/Button'
import TripsList from 'components/TripsList'

import worldMapImg from 'assets/world-map.png'
import './styles.css'

function tripsByGroup(trips) {
  const now = moment()
  const past = []
  const current = []
  const future = []
  trips.forEach((trip) => {
    const start = moment(trip.startDate)
    const end = moment(trip.endDate)
    if (start.isAfter(now)) {
      future.push(trip)
    } else if (end.isAfter(now)) {
      current.push(trip)
    } else {
      past.push(trip)
    }
  })
  return {
    past,
    current,
    future,
  }
}

function getTripsVisibility({ past, current, future, }) {
  const sectionsVisible = []
  if (current.length) {
    sectionsVisible.push('current')
  } else if (future.length) {
    sectionsVisible.push('future')
  } else if (past.length) {
    sectionsVisible.push('past')
  }
  return sectionsVisible
}

class MyTrips extends Component {
  static propTypes = {
    trips: PropTypes.arrayOf(PropTypes.object).isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      pastTrips: [],
      currentTrips: [],
      futureTrips: [],
      sectionsVisible: [],
    }
  }

  componentWillMount() {
    const {
      past,
      current,
      future,
    } = tripsByGroup(this.props.trips)
    const sectionsVisible = getTripsVisibility({ past, current, future, })
    this.setState({
      pastTrips: past,
      currentTrips: current,
      futureTrips: future,
      sectionsVisible,
    })
  }

  componentWillReceiveProps(nextProps) {
    const {
      past,
      current,
      future,
    } = tripsByGroup(nextProps.trips)
    const sectionsVisible = !this.state.sectionsVisible.length ? getTripsVisibility({ past, current, future, }) : this.state.sectionsVisible
    this.setState({
      pastTrips: past,
      currentTrips: current,
      futureTrips: future,
      sectionsVisible,
    })
  }

  toggleSection = (section) => {
    const {
      sectionsVisible,
    } = this.state
    const index = sectionsVisible.indexOf(section)
    if (index === -1) {
      this.setState({
        sectionsVisible: [...sectionsVisible, section],
      })
    } else {
      this.setState({
        sectionsVisible: [
          ...sectionsVisible.slice(0, index),
          ...sectionsVisible.slice(index + 1),
        ],
      })
    }
  }

  render() {
    const {
      actions,
    } = this.props
    const {
      pastTrips,
      currentTrips,
      futureTrips,
      sectionsVisible,
    } = this.state
    const {
      toggleSection,
    } = this

    const hasCurrentTrips = currentTrips.length > 0
    const hasFutureTrips = futureTrips.length > 0
    const hasPastTrips = pastTrips.length > 0

    const toggleCurrent = () => (hasCurrentTrips ? toggleSection('current') : null)
    const toggleFuture = () => (hasFutureTrips ? toggleSection('future') : null)
    const togglePast = () => (hasPastTrips ? toggleSection('past') : null)

    return (
      <div className="MyTrips" style={{ backgroundImage: `url(${worldMapImg})` }}>
        <div className="my-trips-inner">
          {(pastTrips.length > 0 || currentTrips.length > 0 || futureTrips.length > 0) ? (
            <div>

              {/* Don't show current trips - this is OK to be a transient thing which only appears when the context is necessary */}
              {hasCurrentTrips && (
                <div className="trip-group trip-group-current">
                  <h5 onClick={toggleCurrent}>
                    Current Trips ({currentTrips.length})
                  </h5>
                  {sectionsVisible.indexOf('current') > -1 && (
                    <div className="trip-group-content">
                      <TripsList trips={currentTrips} actions={actions} />
                    </div>
                  )}
                </div>
              )}

              {/* Show future trips, or an empty list, as a CTA to plan a trip */}
              <div className="trip-group trip-group-future">
                <h5 onClick={toggleFuture}>
                  Upcoming Trips {hasCurrentTrips ? <span>({futureTrips.length})</span> : null}
                </h5>
                <div className="trip-group-content">
                  {hasFutureTrips && (
                    sectionsVisible.indexOf('future') > -1 && (
                      <TripsList trips={futureTrips} actions={actions} />
                    )
                  )}
                  <div>
                    <Button onClick={actions.addTrip}> Create Trip </Button>
                  </div>
                </div>
              </div>

              {/* Don't show past trips if there aren't any - user would only expect to see these if they have any */}
              {pastTrips.length > 0 && (
                <div className="trip-group trip-group-past">
                  <h5 onClick={togglePast}>
                    Past Trips ({pastTrips.length})
                  </h5>
                  {hasPastTrips && sectionsVisible.indexOf('past') > -1 && (
                    <div className="trip-group-content">
                      <TripsList trips={pastTrips} actions={actions} />
                    </div>
                  )}
                </div>
              )}
            </div>
          ) : (
            <p> <Button onClick={actions.addTrip}> Create your first trip! </Button> </p>
          )}
        </div>
      </div>
    )
  }
}

export default MyTrips



// WEBPACK FOOTER //
// ./src/components/MyTrips/index.js